import { confirmAlert } from 'react-confirm-alert';

import { DeleteFaceConfirmation } from './DeleteFaceConfirmation';

interface ConfirmDeleteFaceProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}
export function confirmDeleteFace({
  onConfirm,
  onReject = undefined,
}: ConfirmDeleteFaceProps): void {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <DeleteFaceConfirmation
          onConfirm={() => {
            onConfirm();
            onClose();
          }}
          onReject={() => {
            onReject?.();
            onClose();
          }}
        />
      );
    },
  });
}
